import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export default (props) => {
    return !!props.errors && !!props.errors.length && _jsx(_Fragment, { children: _jsx("ul", { className: "text-danger", children: props.errors.map((error) => _jsxs("li", { children: [!!error.field ? `${props.mapping && error.field in props.mapping ? props.mapping[error.field] : error.field}: ` : '', error.message] }, `${error.field || '_'}-${error.message}`)) }) });
};
